import { render, staticRenderFns } from "./afterService.vue?vue&type=template&id=2695b953&scoped=true"
import script from "./afterService.vue?vue&type=script&lang=js"
export * from "./afterService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2695b953",
  null
  
)

export default component.exports